(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEntityUserAcl', drvEntityUserAcl);

    drvEntityUserAcl.$inject = ['SystemService'];

    /**
     * @ngdoc directive
     * @name drvEntityUserAcl
     *
     * @description
     * Shows entity template ACL for a user.
     *
     * # Scope bindings
     * {object} user - An entity object for the user.
     * {array} userAcl - An array of entity template ACL objects.
     */
    function drvEntityUserAcl(SystemService) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: 'app/entity-user-acl.tmpl.html',
            scope: {
                user: '=',
                userAcl: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.templateHasOverride = templateHasOverride;
            scope.templateHasGrant = templateHasGrant;
            scope.templateHasDeny = templateHasDeny;
            scope.templateGrantClick = templateGrantClick;
            scope.templateDenyClick = templateDenyClick;
            scope.templateOverrideClick = templateOverrideClick;
            scope.templateShowsOverride = templateShowsOverride;

            var entityTypesRequiringAdmin = SystemService.getEntityTypesRequiringAdminAccess();

            function templateHasOverride(entityTemplateId) {
                var acl = _.find(scope.userAcl, { EntityTemplateId: entityTemplateId });
                return acl.ExplicitGrant !== null;
            }

            function templateHasGrant(entityTemplateId) {
                if (templateRequiresAdmin(entityTemplateId)) {
                    return userIsAdmin();
                } else {
                    var acl = _.find(scope.userAcl, { EntityTemplateId: entityTemplateId });
                    return acl.ExplicitGrant || (acl.ExplicitGrant === null && acl.DefaultGrant);
                }
            }

            function templateHasDeny(entityTemplateId) {
                if (templateRequiresAdmin(entityTemplateId)) {
                    return !userIsAdmin();
                } else {
                    var acl = _.find(scope.userAcl, { EntityTemplateId: entityTemplateId });
                    return acl.ExplicitGrant === false || (acl.ExplicitGrant === null && acl.DefaultGrant === false);
                }
            }

            function templateGrantClick(entityTemplateId) {
                var acl = _.find(scope.userAcl, { EntityTemplateId: entityTemplateId });
                acl.ExplicitGrant = true;
            }

            function templateDenyClick(entityTemplateId) {
                var acl = _.find(scope.userAcl, { EntityTemplateId: entityTemplateId });
                acl.ExplicitGrant = false;
            }

            function templateOverrideClick(entityTemplateId) {
                var acl = _.find(scope.userAcl, { EntityTemplateId: entityTemplateId });

                if (templateHasOverride(entityTemplateId)) {
                    acl.ExplicitGrant = null;
                } else {
                    acl.ExplicitGrant = templateHasGrant(entityTemplateId);
                }
            }

            function templateShowsOverride(entityTemplateId) {
                // Entity templates that require admin access do not show the override tickbox
                return !templateRequiresAdmin(entityTemplateId);
            }

            function templateRequiresAdmin(entityTemplateId) {
                var acl = _.find(scope.userAcl, { EntityTemplateId: entityTemplateId });
                return entityTypesRequiringAdmin.indexOf(acl.EntityTemplateType) !== -1;
            }

            function userIsAdmin() {
                return scope.user.ActivityPermissions.indexOf('administrator') !== -1;
            }
        }
    }
})();